import LoadingButton from "@mui/lab/LoadingButton";
import { Stack } from "@mui/material";
import { DiscardButton } from "./DiscardButton";
import { useTranslation } from "../../hooks/useTranslation";

type ActionButtonsProps = {
  reset: () => void;
  isDirty: boolean;
  isLoading: boolean;
};

export const ActionButtons = ({
  isLoading,
  isDirty,
  reset,
}: ActionButtonsProps) => {
  const { translate } = useTranslation("buttons");
  return (
    <Stack direction={"row"} justifyContent={"flex-end"} gap={2}>
      <DiscardButton reset={reset} isDirty={isDirty} />
      <LoadingButton
        loading={isLoading}
        disabled={isLoading || !isDirty}
        variant="contained"
        type="submit"
      >
        {translate("save")}
      </LoadingButton>
    </Stack>
  );
};
